import React from "react";
import { LastMonthExpenseCard } from "./LastMonthExpenseCard";
import { LastMonthExpenseInsightsPanel } from "./LastMonthExpenseInsightsPanel";
import { useLastMonthExpense } from "../../hooks/useLastMonthExpense";
import { useLastMonthExpenseInsights } from "../../hooks/useLastMonthExpenseInsights";

export function LastMonthExpenseSection() {
  const {
    monthLabel,
    statusLabel,
    expenseAmount,
    momPercent,
    revenuePercent,
    barHeights,
    barLabels,
    barAmounts,
    loading,
    error: expenseError,
  } = useLastMonthExpense();

  const insightsData = useLastMonthExpenseInsights({
    enabled: !loading && !expenseError,
  });

  const insightsMonthLabel =
    insightsData.monthLabel !== ""
      ? `${insightsData.monthLabel} · Insights`
      : (monthLabel ?? "").replace(" · Closed", " · Insights");

  const insightsPanelLoading = loading || insightsData.loading;
  const insightsToShow = insightsData.error ? [] : insightsData.insights;

  return (
    <div className="flex w-full flex-col items-start gap-4 rounded-lg bg-white px-6 py-6 shadow-sm">
      <div className="flex w-full gap-6 items-stretch">
        <LastMonthExpenseCard
          monthLabel={monthLabel}
          statusLabel={statusLabel}
          expenseAmount={expenseAmount}
          momPercent={momPercent}
          revenuePercent={revenuePercent}
          barHeights={barHeights}
          barLabels={barLabels}
          barAmounts={barAmounts}
          loading={loading}
        />
        <LastMonthExpenseInsightsPanel
          monthLabel={insightsMonthLabel}
          insights={insightsToShow}
          loading={insightsPanelLoading}
        />
      </div>
    </div>
  );
}
